module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"infinity\"-in-long-beach-california-b7c0f44a0abfeedfbbfc90e78f0f5b75.png";